import React, { createContext, useState, useContext } from "react";

const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const [feedbackList, setFeedbackList] = useState([]);

  const fetchFeedback = async () => {
    try {
      const response = await fetch("https://drhvac-app.com/api/ratings/get-feedback");
      if (!response.ok) {
        throw new Error("Failed to fetch feedback");
      }
      const data = await response.json();
      setFeedbackList(data);
    } catch (error) {
      console.error("Error fetching feedback:", error);
    }
  };

  const addFeedback = async (email, comment) => {
    try {
      const response = await fetch("https://drhvac-app.com/api/ratings/save-feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, comment }),
      });
      if (!response.ok) {
        throw new Error("Failed to submit feedback");
      }
      await fetchFeedback(); // Refresh the feedback list after a new submission
    } catch (error) {
      console.error("Error saving feedback:", error);
    }
  };

  return (
    <FeedbackContext.Provider value={{ feedbackList, fetchFeedback, addFeedback }}>
      {children}
    </FeedbackContext.Provider>
  );
};

export const useFeedback = () => useContext(FeedbackContext);
